import { render, staticRenderFns } from "./App.vue?vue&type=template&id=142fc834"
import script from "./App.vue?vue&type=script&lang=coffee"
export * from "./App.vue?vue&type=script&lang=coffee"
import style0 from "./App.vue?vue&type=style&index=0&id=142fc834&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports